import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, ArrowUpRight } from "lucide-react";

const footerLinks = [
  {
    title: "Company",
    links: [
      { name: "About Us", path: "/about" },
      { name: "Global Presence", path: "/global-presence" },
      { name: "Product Portfolio", path: "/portfolio" },
    ],
  },
  {
    title: "Partners",
    links: [
      { name: "Become a Customer", path: "/become-customer" },
      { name: "Become a Supplier", path: "/become-supplier" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-bg border-t border-line">
      <div className="max-w-7xl mx-auto px-fluid py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16">
          {/* Logo & Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block">
              <span className="font-heading text-2xl font-bold tracking-wider text-ink uppercase">
                OPTR<span className="text-cyan">E</span>NEX
              </span>
            </Link>
            <p className="mt-6 text-dim text-sm leading-relaxed max-w-sm">
              Optrenex Group — Powering Global Gaming Distribution.
              B2B wholesale of video games, consoles, digital codes & accessories from Dubai and Mumbai.
            </p>
            <div className="mt-8 space-y-4">
              <div className="flex items-start gap-3 text-dim text-sm">
                <MapPin size={16} className="text-cyan shrink-0 mt-0.5" />
                <span>Office 120 &amp; 121, Al Salam Building, Al Buteen, Murshid Bazar, Al Sabkha, Deira, Dubai, UAE — PO Box 1540 | Mumbai, India</span>
              </div>
              <div className="flex items-center gap-3 text-dim text-sm group">
                <Mail size={16} className="text-cyan shrink-0" />
                <a href="mailto:sales@optrenex.com" className="hover:text-cyan transition-colors">
                  sales@optrenex.com
                </a>
              </div>
              <div className="flex items-center gap-3 text-dim text-sm group" data-testid="footer-landline">
                <Phone size={16} className="text-cyan shrink-0" />
                <a href="tel:+97145723353" className="hover:text-cyan transition-colors">
                  +971-45723353
                </a>
              </div>
            </div>
          </div>

          {/* Nav Link Columns */}
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-ink mb-6">
                {section.title}
              </h4>
              <ul className="space-y-4">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="group flex items-center gap-2 text-dim text-sm hover:text-cyan transition-colors duration-300"
                    >
                      <span>{link.name}</span>
                      <ArrowUpRight size={12} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Get In Touch */}
          <div>
            <h4 className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-ink mb-6">
              Get In Touch
            </h4>
            <ul className="space-y-4">
              <li>
                <Link 
                  to="/contact" 
                  className="group flex items-center gap-2 text-dim text-sm hover:text-cyan transition-colors duration-300"
                >
                  <span>Contact Us</span>
                  <ArrowUpRight size={12} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                </Link>
              </li>
              <li>
                <a 
                  href="https://b2b.optrenex.com/login" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="group flex items-center gap-2 text-dim text-sm hover:text-cyan transition-colors duration-300"
                >
                  <span>B2B Login</span>
                  <ArrowUpRight size={12} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                </a>
              </li>
              <li>
                <a 
                  href="https://b2b.optrenex.com/register" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="group flex items-center gap-2 text-dim text-sm hover:text-cyan transition-colors duration-300"
                >
                  <span>B2B Register</span>
                  <ArrowUpRight size={12} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Notch Separator */}
        <div className="my-12">
          <svg viewBox="0 0 1200 40" className="w-full h-10 text-line" preserveAspectRatio="none">
            <path 
              d="M0 20 H560 L580 0 L600 20 L620 0 L640 20 H1200" 
              stroke="currentColor" 
              strokeWidth="1" 
              fill="none"
            />
          </svg>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-dim/60 text-xs font-mono">
            &copy; {new Date().getFullYear()} Optrenex International Private Limited (CIN: U47990MH2025PTC451227). All rights reserved.
          </p>
          <p className="text-dim/60 text-xs font-mono">
            UAE: Optrenex International General Trading LLC (TL: 1546242)
          </p>
        </div>
      </div>
    </footer>
  );
}
